
export const blackWhiteTheme = {
  body: "#ffffff",
  text: "#000000",
  highlight: "#eaece5",
  dark: "#33150A",
  secondaryText: "#000000",
  imageHighlight: "#535353",
  compImgHighlight: "#000000",
  jacketColor: "#000000",
  headerColor: "#b2c2bf",
  grassColor: "#307416",
  shoeColor: "#272727",
  redColor: "#e7393c"
};

export const chosenTheme = blackWhiteTheme;
